export default __webpack_public_path__ + "static/media/app_image.5d2a56b8.svg";